module.exports = __webpack_public_path__ + "static/media/vertical-distribute-bottom.c1f4a0d6.svg";